var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:_vm.orderNum > 0 && _vm.$route.name!=='HomeWaimaiIndex' ? 'orderTop' : 'originTop'},[_c('home-common-search',{staticClass:"search-wrapper"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }